module.exports = __webpack_public_path__ + "static/media/play.e42f13d2.mp3";